import { gql } from "@apollo/client";

import { EVENT_TEMPLATE_FRAGMENT } from "./fragments/eventTemplate";

export const CREATE_EVENT_TEMPLATE = gql`
  ${EVENT_TEMPLATE_FRAGMENT}
  mutation CreateEventTemplate($input: EventTemplateCreateInput!) {
    eventTemplateCreate(input: $input) {
      ...EventTemplate
    }
  }
`;

export const UPDATE_EVENT_TEMPLATE = gql`
  ${EVENT_TEMPLATE_FRAGMENT}
  mutation UpdateEventTemplate($id: Int!, $input: EventTemplateUpdateInput!) {
    eventTemplateUpdate(id: $id, input: $input) {
      ...EventTemplate
    }
  }
`;

export const DELETE_EVENT_TEMPLATE = gql`
  ${EVENT_TEMPLATE_FRAGMENT}
  mutation DeleteEventTemplate($id: String!) {
    eventTemplateDelete(id: $id) {
      ...EventTemplate
    }
  }
`;
